import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ServiceContract } from '../Components/types';
import { ServiceContractsSlice } from './Types';

export const initialState: ServiceContractsSlice = {
	connectedByUnitId: {},
};

// TODO: temporary, in-memory only. Remove together with the mocked service contracts once the API is available.
export const serviceContractsSlice = createSlice({
	name: 'serviceContracts',
	initialState,
	reducers: {
		addConnectedServiceContract: (
			state,
			{
				payload: { unitId, serviceContract },
			}: PayloadAction<{
				unitId: number;
				serviceContract: ServiceContract;
			}>
		) => {
			state.connectedByUnitId[unitId] = [
				...(state.connectedByUnitId[unitId] ?? []),
				serviceContract,
			];
		},
	},
});

export const {
	actions: { addConnectedServiceContract },
} = serviceContractsSlice;

export default serviceContractsSlice.reducer;
